module.exports = __webpack_public_path__ + "fonts/AvenirNextCyr-BoldItalic.158364d2.eot";